/**
 * API Configuration Constants
 *
 * Centralized timeout and configuration values for API requests.
 */

/**
 * Target year for this year's wrapped
 * This is the year users are setting intentions FOR (e.g., 2025)
 * Update this constant each year when preparing a new wrapped
 */
export const WRAPPED_TARGET_YEAR = 2025

export const API_TIMEOUTS = {
  /** Default timeout for standard API requests (10 seconds) */
  default: 10_000,
  /** Extended timeout for AI-powered endpoints (90 seconds) */
  ai: 90_000,
  /** Timeout for file uploads (60 seconds) */
  upload: 60_000,
} as const

export const SYNTHESIS_TIMEOUT = 20_000

export const GENERATION_STEP_DURATIONS = {
  horoscope: 2000,
  photos: 2500,
  narrative: 2000,
  intentions: 1500,
  theme: 1500,
} as const

/**
 * Retry configuration for API requests
 */
export const RETRY_CONFIG = {
  /** Maximum number of retry attempts */
  maxRetries: 3,
  /** Base delay between retries in milliseconds */
  baseDelayMs: 1000,
  /** Maximum delay cap in milliseconds */
  maxDelayMs: 10_000,
  /** HTTP status codes that should trigger a retry */
  retryableStatuses: [408, 429, 500, 502, 503, 504],
} as const

/**
 * AI-specific retry configuration (fewer retries, longer timeouts)
 */
export const AI_RETRY_CONFIG = {
  maxRetries: 2,
  baseDelayMs: 2000,
  maxDelayMs: 15_000,
  retryableStatuses: [408, 429, 500, 502, 503, 504],
} as const
